const endpoints = {
  Me: "/api/Users/Me",
  Users: "/api/Users",
  UserAD: `/api/Users/GetFromAAD/`,
  Roles: "/api/Roles",
  UpdateRoles: (userId) => `api/Users/${userId}/Roles`,
  ProfileImage: "/me/photos/48x48/$value",
  Machines: "/api/Machines",
  Clinics: "/api/Machines/Clinics",
  MachineSerial: "/api/Machines/SerialNumber",
  MachineUses: "/api/Machines/Uses",
  MachineHardwareVersion: "/api/Machines/HardwareVersion",
  MachineSoftwareVersion: "/api/Machines/SoftwareVersion",
  Locations: "/api/Machines/Locations",
  KpiCounts: "/api/Summary/GetPortalKpiCount",
  Runs: "/api/Runs",
  RunDetails: (runId: number | string) => `/api/Runs/${runId}`,
  RunSummary: (runId: number | string) => `/api/Runs/${runId}/Summary`,
  RunComments: (runId: number | string) => `/api/Runs/${runId}/Comments`,
  RunComment: (runId: number | string, id: number | string) =>
    `/api/Runs/${runId}/Comments/${id}`,
  RunLogs: (runId: number | string) => `/api/Runs/${runId}/Logs`,
  RunSensors: (runId: number | string) => `/api/Runs/${runId}/Sensors`,
  RunSensorVariable: (id: number | string) => `/api/Runs/${id}/SensorVariables`,
  RunType: "/api/Runs/RunTypes",
  RunTimeSnap: (runId: number | string) => `/api/Runs/${runId}/Timesnap`,
  MachineSummary: (machineId: number | string) =>
    `/api/Machines/${machineId}/Summary`,
  ServiceRecords: (machineId: number | string) =>
    `/api/Machines/${machineId}/ServiceRecord`,
  MachineLogs: (serialNumber: number | string) =>
    `/api/Machines/${serialNumber}/MachineLogs`,
  MachineLogTypes: `/api/Machines/LogTypes`,
  ReasonForServiceTypes: "/api/Machines/ReasonForServiceTypes",
  LogUpload: (serialNumber: string) => `/api/Machines/${serialNumber}/LogFile`,
  ServiceRecord: (serviceRecordId: number | string) =>
    `api/Machines/ServiceRecord/${serviceRecordId}`,
  Softwares: "/api/Software",
  DeleteSoftware: (softwareId: number | string) =>
    `/api/Software/${softwareId}`,
  DownloadLogFile: (serialNumber: string) =>
    `/api/Machines/${serialNumber}/DownloadLogFile`,
  AllowedSoftwareUpgrade: `/api/Machines/AllowedSoftwareUpgrades`,
  SoftwareUpgradeRequest: "/api/Machines/SoftwareUpgradeRequest",
  LatestSoftware: (machineId: number | string) =>
    `/api/Machines/${machineId}/LatestSoftware`,
  DownloadSoftware: (serialNumber: string) =>
    `/api/Machines/${serialNumber}/DownloadSoftware`,
  UploadSoftware: "/api/Software/Upload",
  AuditLogs: "/api/auditLogs",
  Events: "/api/auditlogs/events",
  UserLogout: "/api/Users/Logout",
  LocationType: "/api/Machines/LocationTypes",
  TermsAndConditions: "https://quantadt.com/uk/terms-of-use/",
  PrivacyPolicy: "https://quantadt.com/uk/privacy-policy/"
};

export default endpoints;
